/* global Metafans_JS */
import { sharingSpinnerSmall } from './templates.js';

/**
 * Checks if a string is a valid URL.
 * @param {string} str The string to check.
 * @returns {boolean} True if the string is a URL.
 */
function isURL(str) {
    const pattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
        "i"
    );
    return !!pattern.test(str);
}

/**
 * Handles the paste event on the activity form to detect and preview URLs.
 * @param {ClipboardEvent} e The paste event.
 */
async function handlePaste(e) {
    const editor = e.target;
    const submitBtn = document.getElementById("aw-whats-new-submit");
    if (submitBtn) {
        submitBtn.removeAttribute("disabled");
    }

    e.preventDefault();
    const text = e.clipboardData.getData("text");

    if (isURL(text)) {
        document.execCommand("insertHTML", false, text);

        const existingPreview = editor.parentElement.querySelector(".url-scrap-view");
        if (existingPreview) return;

        const loader = document.createElement('div');
        loader.className = 'url-scrap-view loading';
        loader.innerHTML = sharingSpinnerSmall;
        editor.after(loader);

        const payload = new URLSearchParams({
            action: "tophive_bp_get_scrapped_html",
            url: text,
        });

        try {
            const response = await fetch(Metafans_JS.ajaxurl, {
                method: "POST",
                body: payload,
            });
            const data = await response.json();
            loader.innerHTML = data;
            loader.classList.remove("loading");

            const urlPreviewInput = document.getElementById("whats-new-post-url-preview");
            if (urlPreviewInput) {
                urlPreviewInput.value = text;
            }
        } catch (error) {
            console.error("URL scraping failed:", error);
            loader.remove();
        }
    } else {
        document.execCommand("insertHTML", false, text);
    }
}

/**
 * Initializes the URL preview functionality.
 */
export function init() {
    const editor = document.querySelector(".advanced-th-bp-activity-form");
    if (editor) {
        editor.addEventListener("paste", handlePaste);
    }

    document.addEventListener("click", (e) => {
        if (e.target.matches("#whats-new-textarea .url-scrap-view .cross")) {
            const urlPreviewInput = document.getElementById("whats-new-post-url-preview");
            if (urlPreviewInput) urlPreviewInput.value = "";
            e.target.closest(".url-scrap-view")?.remove();
        }
    });
}